var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"capability-card",style:(_vm.cardStyle)},[_c('h3',{staticClass:"capability-card__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"capability-card__img"},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.title}})]),_c('p',{staticClass:"capability-card__desc"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }